// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_confirmation-later-process {
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: flex-start;
  width: 100%;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 24px;
  min-height: calc(77vh - 120px);
}
.container_confirmation-later-process h4 {
  color: #00254A;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 133.333% */
}
.container_confirmation-later-process p {
  color: #363A44;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: 0px;
}
.container_confirmation-later-process .container_confirmation-later-process__date {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 104px;
  gap: 12px;
  border-radius: 8px;
  background: #F7F7F7;
  padding: 16px 30px;
}
.container_confirmation-later-process h1 {
  color: #00254A;
  text-align: center;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px; /* 112.5% */
}

.container_confirmation-later-process__footer-text {
  color: #363A44;
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
}

.container_confirmation-later-process__footer-link {
  color: #005CB9 !important;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-decoration-line: underline !important;
}`, "",{"version":3,"sources":["webpack://./src/infraestructure/pages/follow-later/style.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,8BAAA;AACF;AAAC;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;AAEH;AAAC;EACG,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AAEJ;AAAE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACC,mBAAA;EACD,aAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAEJ;AAAE;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAEJ;;AAEA;EACE,cAAA;EACF,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;AACA;;AAGA;EACE,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;AAAF","sourcesContent":[".container_confirmation-later-process{\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  align-items: flex-start;  \n  width: 100%; \n  padding-left: 16px;\n  padding-right: 16px;\n  padding-top: 24px;\n  min-height: calc(77vh - 120px);\n h4 {\n   color: #00254A;\n   font-family: Roboto;\n   font-size: 18px;\n   font-style: normal;\n   font-weight: 700;\n   line-height: 24px; /* 133.333% */\n }\n p {\n    color: #363A44;\n    font-family: Roboto;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n    margin: 0px;\n }\n  .container_confirmation-later-process__date {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n     align-items: center;\n    height: 104px;\n    gap: 12px;\n    border-radius: 8px;\n    background:  #F7F7F7;\n    padding: 16px 30px;\n  }\n  h1{\n    color: #00254A;\n    text-align: center;\n    font-family: Roboto;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 36px; /* 112.5% */\n  }\n}\n\n.container_confirmation-later-process__footer-text {\n  color: #363A44;\ntext-align: center;\nfont-family: Roboto;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 400;\nline-height: 20px; /* 142.857% */\n  \n}\n\n.container_confirmation-later-process__footer-link {\n  color:  #005CB9 !important;\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  text-decoration-line: underline !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
